export default "__VITE_ASSET__nRIH_Fe5__"